module.exports = __webpack_public_path__ + "img/ANDRE_NEVES.b4b66a43.jpg";